import { render, staticRenderFns } from "./CarouselBlog.vue?vue&type=template&id=42165832&"
import script from "./CarouselBlog.vue?vue&type=script&lang=js&"
export * from "./CarouselBlog.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBlog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogCard: require('/opt/buildhome/repo/components/Blog/Card.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
